module.exports = {
  'selectLanguage': 'Selectionner la langue',
  'tags': 'Tags',
  'tags.allTagsLink': 'Parcourir tous les tags',
  'home': 'Accueil',
  'about': 'A propos',
  'axes': 'Axes',
  'acces_art': 'Acces à l\'art',
  'introduction': 'Introduction',
  'contact': 'Contact',
  'contact.infos': 'Informations de contact',
  'not_found': "404 - Page non trouvée",
  '404': "Vous êtes arrivé sur une page qui n'existe plus ou vous avez pris le mauvais chemin ...",
  'copyright': "2019, GuideMuseal - Tous droits réservés.",
  'navigation':"Navigation",
  'tapestry':"Tapisserie",
  'titre_tapisserie':"Découverte d'extraits de la tapisserie de Bayeux",
  'explications_tapisserie2':"Survolez les divers éléments de la tapisserie pour les mettre en avant ainsi que pour faire apparaitre une explication audio.",
  'scene22':"Scène 22 de la tapisserie de Bayeux",
};
